import script from "./Insulation05Extras.vue?vue&type=script&setup=true&lang=js"
export * from "./Insulation05Extras.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__